<template>
    <div class="comment">   
        <el-dialog
            v-model="dialogVisible"
            title="评价与反馈"
            @close="close"
            width="600"
            destroy-on-close
            :close-on-click-modal="false"
        >
            <div>
                <el-form
                    label-position="top"
                    ref="ruleFormRef"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="auto"
                >
                    <el-form-item label="1.课程质量-你觉得课程播放时是否足够清晰流畅，体验舒畅" prop="quality">
                        <el-segmented size="large" v-model="ruleForm.quality" :options="options">
                            <template #default="scope">
                                <div>{{ scope.item.label }}</div>
                            </template>
                        </el-segmented>
                    </el-form-item>
                    <el-form-item label="2.老师讲法-你觉得老师讲的做到突出重点，简洁明了" prop="teach">
                        <el-segmented size="large" v-model="ruleForm.teach" :options="options">
                            <template #default="scope">
                                <div>{{ scope.item.label }}</div>
                            </template>
                        </el-segmented>
                    </el-form-item>
                    <el-form-item label="3.综合感受-我对这节课的综合感受" prop="feel">
                        <el-segmented size="large" v-model="ruleForm.feel" :options="options">
                            <template #default="scope">
                                <div>{{ scope.item.label }}</div>
                            </template>
                        </el-segmented>
                    </el-form-item>
                    <el-form-item label="4.偶尔吐槽-我还有其他话要说，别拦着" prop="comment">
                        <el-input maxlength="500" show-word-limit v-model="ruleForm.comment" type="textarea" :rows="5" />
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitForm(ruleFormRef)">
                            提交
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { commentSaveApi } from "@/api/userPlay/index";
const {fileId,stuId,subjectId} = defineProps({
    fileId:{
        type:String, //视频id
        default:"",
        required:true
    },
    stuId:{
        type:String,//学员id
        default:"",
        required:true
    },
    subjectId:{ //科目id
        type:String,
        default:"",
        required:true
    }
})
const dialogVisible = defineModel('show',{
    default:false,
    required:true
})
const options= [
    { label: '非常差',value: 1 },
    { label: '差',value: 2 },
    { label: '正常',value: 3 },
    { label: '好',value: 4 },
    { label: '非常好',value: 5 },
]
const ruleForm = ref({
    quality: null,
    teach: null,
    feel: null,
    comment:""
})
const close = ()=>{
    ruleForm.value = {
        quality: null,
        teach: null,
        feel: null,
        comment:""
    }
}
const rules = reactive({
    quality: [
        {
            required: true,
            message: '请选择',
            trigger: 'change',
        },
    ],
    teach: [
        {
            required: true,
            message: '请选择',
            trigger: 'change',
        },
    ],
    feel: [
        {
            required: true,
            message: '请选择',
            trigger: 'change',
        },
    ],
})
const emits = defineEmits(['success'])
const ruleFormRef = ref(null)
const submitForm = (formEl) => {
    if (!formEl) return
    formEl.validate((valid, fields) => {
        if (valid) {
            commentSaveApi({
                ...ruleForm.value,
                fileId,
                stuId,
                subjectId

            }).then(res=>{
                emits('success')
                dialogVisible.value = false;
            })
        } else {
        console.log('error submit!', fields)
        }
    })
}
</script>

<style lang="scss" scoped>
.comment{
    width: 0;
    :deep(.el-segmented){
        .el-segmented__item{
            width: 80px;
        }
    }
}
</style>